import { compact, forEach, map, remove } from 'lodash'
import { produce } from 'immer'
import { ContactData } from '../apis/contact.api'
import { ActionName } from '../components/Actions'
import { TableHorizontalData } from '../components/TableHorizontal'

export default {
  tableHorizontalData (
    contacts: ContactData[]
  ): TableHorizontalData<ContactData>[] {
    forEach(contacts, (contact: TableHorizontalData<ContactData>) => {
      const actions: ActionName[] = ['edit']
      if (!contact.isDeleted) actions.push('delete')
      const siteNames = this.listSiteNames(contact)
      contact.actions = actions
      contact.siteNames = siteNames.join(', ')
    })
    return contacts
  },

  listSiteNames (contact: ContactData) {
    if (!contact.sites) return []
    const names = map(contact.sites, site => {
      const { name } = site
      return name
    })
    return compact(names)
  },

  delete (contacts: TableHorizontalData<ContactData>[], id: number) {
    return produce(contacts, contacts => {
      remove(contacts, { id })
    })
  },

  searchOptions (contacts: ContactData[]) {
    const contactsData = map(contacts, contact => {
      const { contactable, id } = contact
      if (!contactable) return
      const { name } = contactable
      return { id, value: name }
    })
    return compact(contactsData)
  }
}
